import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/_components/DesktopMobileRouteGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/_components/SingleRouteGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/client-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/components/common/DefaultPagePerformanceLifecycleHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/components/common/DeferredI18nDictionaryLoader.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/node_modules/.pnpm/swiper@11.2.10/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/node_modules/.pnpm/swiper@11.2.10/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager", webpackExports: ["I18nBootstrapProvider"] */ "/home/runner/work/tipsy-ui/tipsy-ui/provider/I18nBootstrapProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/provider/MessageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuickTrackingProvider"] */ "/home/runner/work/tipsy-ui/tipsy-ui/provider/QuickTrackingProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RumProvider"] */ "/home/runner/work/tipsy-ui/tipsy-ui/provider/RumProvider.tsx");
